import HttpService from "./http.service";

export const createOrganization = async (data) => {
  return await HttpService.post("/organization", data);
};

export const getOrganizations = async () => {
  return await HttpService.get("/organization");
};

export const getOrganization = async (organizationId) => {
  return await HttpService.get(`/organization/${organizationId}`);
};

export const editOrganization = async (organizationId, data) => {
  return await HttpService.patch(`/organization/${organizationId}`, data);
};

export const deleteOrganization = async (organizationId) => {
  return await HttpService.delete(`/organization/${organizationId}`);
};

export const getOrganizationCost = async (range) => {
  return await HttpService.get(`/organization/cost?range=${range}`);
};

export default {
  createOrganization,
  getOrganizations,
  getOrganization,
  editOrganization,
  deleteOrganization,
  getOrganizationCost,
};